import { delay } from "@/hooks/useReveal";

export const Officer = () => (
  <section id="officer" className="section section--cream" aria-labelledby="officer-title" data-testid="officer-section">
    <div className="container">
      <div className="stack section-head" data-reveal>
        <p className="eyebrow">Your officer</p>
        <h2 id="officer-title" className="title">Reinforcement for your team. Not a replacement for it.</h2>
      </div>
      <div className="officer__grid section-body">
        <div className="prose" data-reveal>
          <p>Most companies don't need another consultant who writes a report and leaves. They need someone who understands both the law and the tools, sits next to the team, and takes the paperwork off their desk so the work can move.</p>
          <p className="prose__muted">That is what AI Arena does. Katarina holds the legal side. Marino runs implementation and operations, so what we recommend is what we set up. We build with AI every day, and everything we deliver is made and checked by people.</p>
        </div>
        <div className="people">
          <article className="person person--lead surface-dark" data-reveal style={delay(1)} data-testid="person-katarina">
            <p className="kicker">Founder · Legal and governance</p>
            <h3 className="person__name">Katarina Bulić Bestulić</h3>
            <p className="person__bio">Attorney at law and EU AI governance expert. 14 years in EU law, from the European Commission in Brussels to the legal foundations of Croatia's first tech unicorn. Has spoken in New York, London, Geneva and Amsterdam.</p>
            <ul className="tags">
              <li className="tag">EU AI Act</li>
              <li className="tag">GDPR</li>
              <li className="tag tag--pending">AIGP · in progress</li>
              <li className="tag tag--pending">CIPP/E · in progress</li>
            </ul>
          </article>
          <article className="person person--support" data-reveal style={delay(2)} data-testid="person-marino">
            <p className="kicker">Implementation and operations</p>
            <h3 className="person__name">Marino Bestulić</h3>
            <p className="person__bio">Sets up the tools we recommend and keeps them running inside your workflows.</p>
          </article>
        </div>
      </div>
    </div>
  </section>
);
